//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import {
  faFacebookF,
  faVimeoV,
  faSoundcloud,
  faTwitter,
  faYoutube,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

export default {
  name: 'artist-profile-sns-card',
  components: {
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faGlobe,
    };
  },
  computed: {
    sns() {
      return _.get(this.artist, 'sns', []);
    },
  },
  methods: {
    getSnsUrl(type) {
      if (type && this.sns.length) {
        const sns = this.sns.find(x => x.type === type);
        return sns.url;
      }
    },
    convertIconName(type) {
      switch (type) {
        case 'soundcloud':
          return faSoundcloud;
        case 'facebook':
          return faFacebookF;
        case 'vimeo':
          return faVimeoV;
        case 'twitter':
          return faTwitter;
        case 'youtube':
          return faYoutube;
        case 'instagram':
          return faInstagram;
        default:
          return type;
      }
    },
  },
};
